exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cls-1[data-v-ffa06ec0] {\r\n  fill: none;\r\n  stroke: #fff;\r\n  stroke-miterlimit: 10;\r\n  stroke-width: 2.26px;\n}\n.cls-2[data-v-ffa06ec0] {\r\n  fill: #fff;\n}\r\n", ""]);

// exports
